<template>
  <div class="notfound">
    <h1>404</h1>
    <p>Deze pagina bestaat niet</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.notfound {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 500px;
  padding: 30px;
  margin: 0 auto;
  text-align: center;
  h1 {
    font-size: 60px;
    margin: 0;
  }
  p {
    font-size: 18px;
  }
}
</style>
